// @flow

import { observer } from "mobx-react";
import React from "react";

import TimelineItem from "app/models/TimelineItem";

import "./AudioTimelineItem.scss";
import playIcon from "app/assets/images/play-icon.png";

type Props = {
    item: TimelineItem,
    scale: number
};

@observer
export default class AudioTimelineItem extends React.Component<Props> {
    render() {
        return (
            <div className="AudioTimelineItem" alt="Audio timeline item">
                <img
                    src={playIcon}
                    alt="Audio Icon"
                    className="AudioTimelineItem__icon"
                />
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/app/components/TimelineItem/AudioTimelineItem/AudioTimelineItem.js